import DesignInput from '../../../../components/input/DesignInput';
import { DateChangeHandler } from '../../types';

export interface OohDateSelectProps {
  dateInputValue: string | null;
  dateChangeHandler: DateChangeHandler;
}

const OohDateSelect = ({
  dateInputValue,
  dateChangeHandler,
}: OohDateSelectProps) => {
  return (
    <div className="flex w-full flex-col">
      <label htmlFor="statisticsDate">Date</label>
      <DesignInput
        name="date"
        type="date"
        max="today"
        step={1}
        id="routeDate"
        onChanceHandler={dateChangeHandler}
        value={dateInputValue ?? ''}
      />
    </div>
  );
};

export default OohDateSelect;
